import { InformationCircleIcon } from "@heroicons/react/24/outline";
import React, { ReactNode } from "react";
import ProductDetailHeader from "./ProjectDetailHeader";
import { CalendarDaysIcon, CalendarIcon, CubeIcon } from "@heroicons/react/24/solid";

interface ProjectHeadeDetails {
  type: string;
  startDate: string;
  deadline: string;
}

interface ProjectDetailCardProps {
  title: string;
  subtitle: string;
  icon: ReactNode
}

const ProjectDetailCard: React.FC<ProjectDetailCardProps> = ({title, subtitle, icon}) => {
  return (
    <div className="flex justify-start space-x-3 px-4 py-6 bg-slate-100 rounded-2xl">
      <div className="p-3 bg-rajapiNavyBlue rounded-xl">
        {icon}
      </div>
      <div className="flex flex-col">
        <span className="block text-sm text-gray-500">{title}</span>
        <span className="text-gray-800 font-medium">{subtitle}</span>
      </div>
    </div>
  );
}

const ProjectDetails: React.FC<ProjectHeadeDetails> = ({
  type,
  startDate,
  deadline,
}) => {
  return (
    <div className="grid gap-2">
      <ProductDetailHeader icon={<InformationCircleIcon className={`w-5 h-5 mr-2 text-black`}/>} label="Détails du projet"/>
      <div className="grid grid-cols-3 gap-2">
        <ProjectDetailCard title="Type de projet" subtitle={type} icon={<CubeIcon className="text-white h-6 w-6"/>}/>
        <ProjectDetailCard title="Date de début" subtitle={startDate} icon={<CalendarIcon className="text-white h-6 w-6"/>}/>
        <ProjectDetailCard title="Deadline" subtitle={deadline} icon={<CalendarDaysIcon className="text-white h-6 w-6"/>}/>
      </div>
    </div>
  );
};

export default ProjectDetails;
